import * as _ from 'underscore';
import { IRemoteRefreshAgentInfo } from '../models/IRemoteRefreshAgentInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { Set } from '../models/Set';
import { IRemoteRefreshAgent } from '../ServerApi/requests/GetRemoteRefreshAgentsRequest';

export module RemoteRefreshAgentMapper {

  export function mapToResource(agents: IRemoteRefreshAgent[]): IRemoteRefreshAgentInfo[] {
    return _.map(agents, (agent: IRemoteRefreshAgent): IRemoteRefreshAgentInfo => {
      const content = new Set<INamedItemInfo>((item: INamedItemInfo) => item.id);
      content.addItems(agent.content);

      return {
        id: agent.id,
        name: agent.name,
        ownerId: agent.ownerId,
        content: content
      };
    });
  }

}
